import Field from "./Component/Field";
function App() {
  return (
    <div className="App">
      <Field />
    </div>
  );
}

export default App;